import Slider from '@mui/material/Slider';
import '../../assets/css/styles.css';

const EnergySlider = ({ value, onChange }) => {
    return (
        <Slider
            className="energy-slider"
            value={value}
            onChange={onChange}
        />
    );
};

export default EnergySlider;
